import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Input, Button, Table } from "antd";

import {
  req_edit_ssp_school_target_detail,
  req_multiple_employee,
} from "../../api";
import storageUtils from "../../utils/storageUtils";
const { Search } = Input;

class DepartmentPrincipalSearchModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    department: {},
    staff: [],
  };

  static propTypes = {
    source: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    const result = await req_edit_ssp_school_target_detail(
      item,
      storageUtils.getUser().token
    );
    // console.log(result);
    if (result.status === "success") {
      message.success("修改成功");
    } else {
      message.error("修改失敗，可能已有相同的數據，請確認");
    }
  };

  api_search_item = async (key) => {
    // console.log(key);
    const result = await req_multiple_employee(
      key,
      storageUtils.getUser().token
    );
    //console.log(result);
    if (result.data === null) {
      message.success("查無此人");
    } else {
      this.setState({ staff: result.data });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////
  onSearch = (value) => {
    //console.log(value);
    if (value.length >= 1) {
      this.api_search_item(value);
    } else {
    }
  };

  onChange = (staff) => {
    const { userCode } = storageUtils.getUser();
    const {
      Gid,
      YearMonth,
      PlanAcademicYear,
      AcademicSystem,
      TargetDepartmentCode,
      SourceCode,
      HighSchoolCode,
      SourceDepartmentCode,
    } = this.props.source;

    const item = {
      condition: "PRINCIPAL", // "Principal",
      Gid,
      YearMonth,
      PlanAcademicYear,
      AcademicSystem,
      TargetDepartmentCode,
      SourceCode,
      HighSchoolCode,
      SourceDepartmentCode,
      PrincipalCode: staff.EmployeeId,
      RecordEditorId: userCode,
    };
    this.api_modify_item(item);
    //console.log(item);
  };

  init_columns = () => {
    this.columns = [
      {
        title: "",
        dataIndex: "",
        render: (item) => {
          const { EmployeeId, TwName } = item;
          return (
            <>
              <>
                <p></p>
                {EmployeeId}/{TwName}
              </>
              <Button
                type="primary"
                size="small"
                onClick={() => this.onChange(item)}
              >
                <i className="fas fa-user-cog"></i>
                <span style={{ marginLeft: "4px" }}> 接任</span>
              </Button>
            </>
          );
        },
      },
    ];
  };

  ////////////////////////////////////////////////////////////

  render() {
    const {
      HighSchoolTwName,
      HighSchoolDepartmentName,
      SourceName,
      PrincipalCode,
      TwName,
    } = this.props.source;
    const { staff } = this.state;
    return (
      <Card>
        <div className="row">
          <div style={{ fontSize: "1.3em" }}>
            <span style={{ fontSize: "0.8em" }}>
              {HighSchoolTwName}/{HighSchoolDepartmentName} ||{" "}
            </span>
            <span style={{ fontSize: "0.8em" }}>招生方式：{SourceName}</span>
            <br></br>
            <span>
              現任負責人：{TwName}({PrincipalCode})
            </span>
          </div>{" "}
          <Search
            placeholder="接任者姓名"
            allowClear
            enterButton={
              <>
                <i className="fas fa-search"></i> 查詢
              </>
            }
            size="small"
            onSearch={this.onSearch}
          />
          <Table
            bordered
            scroll={{ y: 380 }}
            dataSource={staff}
            columns={this.columns}
          />
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(DepartmentPrincipalSearchModal);
